import { render, staticRenderFns } from "./EditGsa.vue?vue&type=template&id=15a33d24&"
import script from "./EditGsa.vue?vue&type=script&lang=js&"
export * from "./EditGsa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports